<template>
  <section class="set-range-step">
    <h4>
      {{ textForStep }}
      <toggle-help-button
        v-bind:helpAreaVisible="helpAreaVisible"
        v-on:toggleHelp="toggleHelp()"
      />
    </h4>
    <slot
      v-if="helpAreaVisible"
      name="rangeHelpSection"
    ></slot>
    <slot name="boardCardsSelector"></slot>
    <range-for-street
      v-bind:player="player"
      v-bind:playerIndex="playerIndex"
      v-bind:playerStateIndex="playerStateIndex"
      v-bind:presetCommunityCards="presetCommunityCards"
      v-bind:presetHoleCards="presetHoleCards"
      v-bind:textWhenFiveCardHandPercentagesArentUpToDate="textWhenFiveCardHandPercentagesArentUpToDate"
      v-bind:storeModuleName="storeModuleName"
      v-bind:authorized="authorized"
    ></range-for-street>
  </section>
</template>

<script>
import RangeForStreet from '@/components/utilities/range-for-street';
import ToggleHelpButton from '@/components/guided-analyses/help/toggle-help-button';

export default {
  name: 'set-range-step',
  components: {
    'range-for-street': RangeForStreet,
    'toggle-help-button': ToggleHelpButton,
  },
  props: [
    'textForStep',
    'player',
    'playerIndex',
    'playerStateIndex',
    'presetCommunityCards',
    'presetHoleCards',
    'textWhenFiveCardHandPercentagesArentUpToDate',
    'storeModuleName',
    'authorized',
  ],
  data: function () {
    return {
      helpAreaVisible: false,
    };
  },
  computed: {
    handRankings: function () {
      return this.$store.getters['account/handRankings'];
    },
  },
  methods: {
    toggleHelp: function () {
      this.helpAreaVisible = !this.helpAreaVisible;
    },
    resetDoubleSlider: function (playerIndex) {
      if (this.$refs['player-' + playerIndex + '-0']) {
        this.$refs['player-' + playerIndex + '-0'].resetDoubleSlider();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/set-range-step.vue